import { ERROR_API } from "../types/errorApiType";

export const setErrorApiAction = (rute, error, code) => (dispatch) => {
    return dispatch({
        type: ERROR_API,
        payload: { rute, error, code },
    });
};

// set error api !!
export const setErrorApi = (error, rute, code = "CodGenerico") => {
    if (!error) {
        error = "Mensaje de error genérico";
    }

    if (typeof error == "object") {
        code = error.code;
        error = error.message[0];
        rute = rute;
    }

    return {
        type: ERROR_API,
        payload: { code, rute, error },
    };
};
